import { useState, useEffect, useRef } from 'react'
import { ESortOrder } from '../components'
import { useSearchParams } from 'react-router'
import * as lib from '../lib'

export const OFFER_SPEND_BY_OFFER_SCOPE_PAGE_SORT_FIELDS = ['scopeId', 'scope.name', 'amount'] as const

export type IOfferSpendByOfferScopeSortField = typeof OFFER_SPEND_BY_OFFER_SCOPE_PAGE_SORT_FIELDS[number]

type IUseOfferSpendByOfferScopeSortPage = {
	sortBy: IOfferSpendByOfferScopeSortField;
	setSortBy: (value: (((prevState: IOfferSpendByOfferScopeSortField) => IOfferSpendByOfferScopeSortField) | IOfferSpendByOfferScopeSortField)) => void;
	order: ESortOrder;
	setOrder: (value: (((prevState: ESortOrder) => ESortOrder) | ESortOrder)) => void;
}

const DEFAULT_SORT_BY: IOfferSpendByOfferScopeSortField = 'scopeId'
const DEFAULT_SORT_ORDER: ESortOrder = ESortOrder.desc
export const useOfferSpendByOfferScopeSortPage = (): IUseOfferSpendByOfferScopeSortPage => {
	const isFirstRender = useRef<boolean>(true)
	const [searchParams, setSearchParams] = useSearchParams()

	const urlSort = (() => {
		try {
			return lib.sortSearchParams(searchParams.get('s')) ?? []
		} catch (error) {
			console.error(error)
			return []
		}
	})().filter((item) => {
		const sortOrderValues = Object.values(ESortOrder)

		return OFFER_SPEND_BY_OFFER_SCOPE_PAGE_SORT_FIELDS.includes(item[0] as IOfferSpendByOfferScopeSortField) && sortOrderValues.includes(item[1] as ESortOrder)
	})

	const [sortBy, setSortBy] = useState<IOfferSpendByOfferScopeSortField>(urlSort?.[0]?.[0] as IOfferSpendByOfferScopeSortField ?? DEFAULT_SORT_BY)
	const [order, setOrder] = useState<ESortOrder>(urlSort?.[0]?.[1] as ESortOrder ?? DEFAULT_SORT_ORDER)
	// const [send, setSend] = useState<boolean>(false)
	//console.log('useOfferSpendByOfferScopeSortPage:: ', { sortUrl: urlSort })

	useEffect(() => {
		let _sortBy = sortBy
		let _order = order

		if (_sortBy && _order) {
			const newSortStr = lib.sortSetup([[_sortBy, _order]])

			setSearchParams((prev) => {
				if (!isFirstRender.current) {
					if (_order !== ESortOrder.unset) {
						prev.set('s', newSortStr)
					} else {
						prev.delete('s')
					}
				} else {
					isFirstRender.current = false
				}

				return prev
			})
		}
	}, [sortBy, order])

	return {
		sortBy,
		setSortBy,
		order,
		setOrder
	}
}